import React from "react";
import RowCardList from "../SubComponent/RowCardList";
import {
    IconAnchor,
    IconChipCircleTools, IconEmployeeInside,
    IconEmployeeOutside, IconGuardTitle,
    NumericFieldChip, OutlinedCalendarIcon, TimePickerChip
} from "../../../../../components/buttons/IconButtons";
import {DATE_TIME_FORMAT_NAME_MODEL, getDateFormat} from "../../../../../Apis/functions";
import CustomGenericTittleIconDataChip from "../../../../../components/CustomGenericTittleIconDataChip";
import CustomCard from "../../../../../components/CustomCard";
import NotInformation from "../../../../../components/NotInformation";
import CustomTooltip from "../../../../../components/CustomTooltip";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 03 de diciembre de 2025
 */


const LogCardModal = ({
    checkInItem,
    checkOutItem,
    out,
    t,
    equipmentIn,
    equipmentOut
}) => {

    const renderEquipmentList = materialList => {
        return (
            <CustomCard classContent="p-0" classCard="border-0">
                {
                    (!materialList?.length) ?
                        <NotInformation className={'h-100'} classNameImage={'h-100px py-1'} text={t('no_information')} card={true} />
                        :
                        materialList?.map(eq => (
                            <RowCardList
                                key={eq?.code}
                                className="p-2"
                                leftPart={
                                    <div className={'justify-content-start d-flex gap-2 align-items-center'}>
                                        <div>
                                            <IconChipCircleTools/>
                                        </div>
                                        <div className={'flex-grow-1 minw-0'}>
                                            <CustomTooltip
                                                text={eq?.label}
                                                classes={`fs-14px ibl-font-w-600 text-ellipsis-1-row`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </div>
                                }
                                rightPart={
                                    <>
                                        <div className={"pr-2"}><NumericFieldChip className={"icon-color-shades-600"}/></div>
                                        <div className={'flex-grow-1 minw-0'}>
                                            <CustomTooltip
                                                text={eq?.code}
                                                classes={`fs-14px font-color-shades-600 ibl-font-w-400 text-ellipsis-1-row`}
                                                showIfTruncated={true}
                                            />
                                        </div>
                                    </>
                                }
                            />
                        ))

                }
            </CustomCard>
        );
    };

    const renderSection = ({ titleKey, data, materialList, isOutSection }) => {
        const insideNumber = equipmentIn.filter(e => !equipmentOut.map(out => out.id).includes(e.id))?.length;
        const showWarning = isOutSection && insideNumber > 0;

        return   <div className="row p-12px">
            <div className={"col-sm-12 col-md-1 px-0"}>
                <div className={`d-flex justify-content-center align-items-center p-3 border-radius-4px
                ${isOutSection ? "background-error-code-100" : "background-primary-100"}`}
                >
                    {isOutSection ? (
                        <IconEmployeeOutside className="w-h-24px" />
                    ) : (
                        <IconEmployeeInside className="w-h-24px" />
                    )}
                </div>
            </div>
            <div className={"col-sm-12 col-md-11"}>
                <div className="p-0 m-0 d-flex flex-column justify-content-start gap-2">
                    <div className="flex-row gap-2">
                        <p className="font-color-general-950 ibl-font-w-600 fs-14px">
                            {t(titleKey)}
                        </p>
                    </div>

                    <div className="d-flex justify-content-start gap-46px">
                        <p className="text-capitalize ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center gap-2">
                            <OutlinedCalendarIcon className="icon-color-shades-500 w-16px h-16px" />
                            {getDateFormat(data?.accessDate, false, DATE_TIME_FORMAT_NAME_MODEL.dayWithShortMonth)}
                        </p>

                        <p className="text-capitalize ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center gap-2">
                            <TimePickerChip className="icon-color-shades-500 w-16px h-16px" />
                            {getDateFormat(data?.accessDate, false, DATE_TIME_FORMAT_NAME_MODEL.time12Uppercase)}
                        </p>
                    </div>

                    <p className="font-color-general-950 ibl-font-w-600 fs-14px">{t("guard")}</p>
                    <p className="text-capitalize ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center gap-2">
                        <IconGuardTitle className="icon-color-shades-500 w-16px h-16px" />
                        {data?.guardFullName}
                    </p>
                    <div className="border-bottom-shades-300 my-3" />

                    {isOutSection && data?.note && (
                        <>

                            <div className="flex-row gap-2">
                                <p className="font-color-general-950 ibl-font-w-600 fs-14px">{t("note")}</p>
                                <p className="fs-14px ibl-font-w-400">
                                    {data?.note}
                                </p>
                            </div>
                            <div className="border-bottom-shades-300 my-3" />
                        </>
                    )}

                    <p className="font-color-general-950 ibl-font-w-600 fs-14px">
                        {t("materials_associate")}
                    </p>

                    {/* BADGE message only on OUT */}
                    { showWarning && (
                        <CustomChip
                            fontColor={colors.warning700}
                            borderColor={colors.warning150}
                            background={colors.warning100}
                            className={'w-100 justify-content-start ibl-font-w-500'}
                            legend={t("x_materials_left_inside", {insideNumber})}
                            showAvatar={false}
                            variant='large'
                        />
                    )}
                    { renderEquipmentList(materialList) }
                </div>
            </div>
        </div>
    };

    return (
        <>
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
                <CustomGenericTittleIconDataChip
                    className="m-0 p-12px"
                    Icon={IconAnchor}
                    title="trail"
                    border={false}
                />

                <div className="border-bottom-shades-300" />

                { out &&
                renderSection({
                    titleKey: "check_out_log",
                    data: checkOutItem,
                    materialList: equipmentOut,
                    isOutSection: true
                })
                }

                { renderSection({
                    titleKey: "check_in_log",
                    data: checkInItem,
                    materialList: equipmentIn,
                    isOutSection: false
                })}
            </CustomCard>

        </>
    );
};

export default LogCardModal;
